import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { ModernCompass } from './ModernCompass';
import { CardTintStreaks } from './UI';

/** Replace the whole wizard while it commits, rather than painting an inset card. */
export function WizardLoadingScreen({ title, detail, children }: {
  title: string;
  detail?: string;
  children?: React.ReactNode;
}) {
  const screen = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const previous = document.activeElement;
    screen.current?.focus();
    return () => { if (previous instanceof HTMLElement && previous.isConnected) previous.focus(); };
  }, []);

  return createPortal(
    <div ref={screen} tabIndex={-1} role="dialog" aria-modal="true" aria-label={title}
      onKeyDown={event => { if (event.key === 'Tab') event.preventDefault(); }}
      className="fixed inset-0 z-[200] isolate overflow-hidden bg-white flex items-center justify-center p-6 outline-none">
      <div className="auth-blobs"><CardTintStreaks /></div>
      <div className="w-full max-w-sm text-center space-y-5">
        <div className="flex justify-center"><ModernCompass size={64} /></div>
        <div role="status" aria-live="polite">
          <h2 className="font-serif ds-title text-app-text">{title}</h2>
          {detail && <p className="mt-2 text-sm text-app-sub break-words">{detail}</p>}
        </div>
        {children}
      </div>
    </div>,
    document.getElementById('import-modal-root') ?? document.body,
  );
}
